import { useQuery } from "@tanstack/react-query";
import { restGet } from "@/lib/supabaseRest";

const SETTING_KEYS = [
  "announcement_banner",
  "head_scripts",
  "site_logo_url",
  "site_favicon_url",
] as const;

type SettingKey = (typeof SETTING_KEYS)[number];

/**
 * Batch-fetches all site_settings rows in a single query, cached for 30 min.
 * Replaces 5+ individual round-trips on initial page load.
 */
export function useSiteSettings(opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["site-settings-batch", "all"],
    queryFn: async () => {
      const keys = SETTING_KEYS.map((k) => `"${k}"`).join(",");
      const data = await restGet<{ key: string; value: unknown }[]>(
        `site_settings?select=key,value&key=in.(${keys})`,
      );
      const map: Record<string, any> = {};
      (data ?? []).forEach((r: any) => { map[r.key] = r.value; });
      return map as Partial<Record<SettingKey, any>>;
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: opts.enabled ?? true,
  });
}
